// Constants
import { LEGIT_AMAZON_URL, LEGIT_DEFAULT_URL } from './constants/app-callback-url.utils.constants';
import {
  INTENTIONAL_NAVIGATION,
  INTENTIONAL_NAVIGATION_ON,
} from 'components/header-layout/constants/header-layout.constants';
// Types
import { AppCallbackUrlUtilsType } from 'utils/types/app-callback-url.utils.type';
// Utilities
import { getCallbackUrlFromQueryParams } from './browser-url.utils';

const isAmazonLegitUrl = (url: string): boolean => url.includes(LEGIT_AMAZON_URL);

const getCallbackLoanUrl = ({
  callbackUrl,
  loanId,
}: AppCallbackUrlUtilsType): string | Location => {
  const redirectionUrl = callbackUrl || getCallbackUrlFromQueryParams();

  return isAmazonLegitUrl(redirectionUrl) ? redirectionUrl : LEGIT_DEFAULT_URL + loanId;
};

const navigateToCallbackUrl = (props: AppCallbackUrlUtilsType): void => {
  localStorage.setItem(INTENTIONAL_NAVIGATION, INTENTIONAL_NAVIGATION_ON);
  const url = getCallbackLoanUrl(props) as any;

  if (isAmazonLegitUrl(url)) {
    window.location = getCallbackLoanUrl(props) as any;
  } else {
    window.location = LEGIT_DEFAULT_URL as any;
  }
};

export { getCallbackLoanUrl, navigateToCallbackUrl };
